/* eslint-disable max-lines */
import { call, put, select, takeLatest, all } from 'redux-saga/effects';
import {
    overlayLoaded,
    setActiveProviderType,
    setError,
    setFamilyFriends,
    setLoading,
    setSelectedTariffId,
    setTariffs,
    setUserInfo,
} from 'Container/App/action';
import { AppActions, OverlayError } from './enum';
import { QueryNames, Cookies } from '../../enums/network';
import { Selected, UserInfo } from './interface';
import { ProviderType } from '../../enums/product';
import { deleteCookie, getCookie, getQueryParam, RequestParams, setCookie } from '@vfde-sails/utils';
import { isNotEmptyString } from '../../util/validator';
import { ApiErrorResponseWithCode, requestHtml } from '@vfde-sails/utils';
import { FF_ERROR_PAGE, SELECTEDID } from '../../constants';
import { selectAccessSupplier, selectProviderType, selectSelected } from './selector';
import { getCMSConfig, getFiberObject, getTariffIds } from '../../util/cms';
import { Overlay } from '@vfde-brix/ws10/overlay';
import { debugInfo } from '../../util/debug';
import { setOverlayVisiblity } from '../../components/overlay';
import { isApiError } from '../AvailabilityCheck/util/typeGuard';
import { trackError } from '../../util/tracking';
import { AvailabilityIndicator,
    JarvisOffersRequest,
    JarvisProduct,
    getJarvisOffers,
} from '@vfde-sails/avc-core';
import { validateFriendsAndFamily } from '../../util/api';
import { getUserInfo } from '../../util/authApi/authApiHandler';
import { setAccessSupplier,
    setAvailabilityIndicator,
    setRolloutEndMonth,
    setRolloutStatus,
} from '../AvailabilityCheck/action';
import { checkIsSafari } from '../../util/formatter';
import { handleShowFloatingButton } from '../../components/fullwidth-notification';
import { selectAvailabilityIndicator,
    selectRolloutEndMonth,
    selectRolloutStatus,
} from 'Container/AvailabilityCheck/selector';
import { handleStepper } from './util/generator';
import { removeGigakombiCookie } from '../../util/cookieHelper';
/*validateFFSaga */
export function* validateFFSaga () {
    const token = getQueryParam(QueryNames.FF);

    if (!isNotEmptyString(token)) {
        return;
    }

    try {
        yield call(validateFriendsAndFamily, token!);

        setCookie(Cookies.FF, { value: token! });

        yield put(setFamilyFriends(true));
    } catch (error) {
        if (error instanceof ApiErrorResponseWithCode) {
            yield put(setError(error));
        } else {
            location.assign(FF_ERROR_PAGE);
        }
        return;
    }

}

export function* getOffersSaga () {
    try {
        const { tariffId }: Selected = yield select(selectSelected);
        const activeProviderType: ProviderType = yield select(selectProviderType);
        const accessSupplier: string = yield select(selectAccessSupplier);
        const rolloutEndMonth: string = yield select(selectRolloutEndMonth);
        const rolloutStatus: string = yield select(selectRolloutStatus);
        const availabilityIndicator: AvailabilityIndicator = yield select(selectAvailabilityIndicator);

        const tariffIds = getTariffIds(activeProviderType);
        const selectedTariffId = tariffId && tariffIds.includes(tariffId)
            ? tariffId : tariffIds[0];

        const request: JarvisOffersRequest = {
            salesChannel: 'FIB',
            selected: selectedTariffId,
            id: tariffIds,
            regioCharge: [],
            availabilityCheck: false,
            ...(accessSupplier && { accessSupplier }),
            ...(rolloutEndMonth && { rolloutEndMonth }),
            ...(rolloutStatus && { rolloutStatus }),
            ...(availabilityIndicator && { availabilityIndicator }),
        };

        const tariffs: JarvisProduct[] = yield call(getJarvisOffers, request);
        yield put(setTariffs(tariffs));

        if (!tariffs.length) {
            throw new Error('Fetching tariffs failed. Tariffs length is 0.');
        }
    } catch (error) {
        yield put(setError(error as Error));

        if (isApiError(error)) {
            trackError(error);
        }
    }
}

export function* initOverlay () {
    try {
        const overlay: Overlay | undefined = getFiberObject()?.overlay;
        const avcConfig = getCMSConfig()?.avc;
        const lmConfig = getCMSConfig()?.lm;

        if (!overlay) { throw new Error(OverlayError.OVERLAY_MISSING); }
        if (!avcConfig) { throw new Error(OverlayError.CONFIG_MISSING_AVC); }
        if (!lmConfig) { throw new Error(OverlayError.CONFIG_MISSING_LM); }

        const requestOptions: RequestParams = {};



        const content: string[] = yield all([
            call(requestHtml, avcConfig.addressForm, requestOptions),
            call(requestHtml, avcConfig.resultLayer, requestOptions),
            call(requestHtml, lmConfig.form, requestOptions),
        ]);

        overlay.injectContent(...content);

        yield put(overlayLoaded());
    } catch (error) {
        debugInfo('Could not initialize overlay: ', error);
    }
}

/**
 * Hides every overlay content and only shows the required content type.
 * Then opens the overlay.
 */
export function* openOverlaySaga () {
    try {
        yield call(setOverlayVisiblity);
    } catch (error) {
        debugInfo('Could not open overlay: ', error);
    }
}

export function* deleteAddressSaga () {
    try {
        const isSafari = checkIsSafari();

        if (isSafari){
            handleShowFloatingButton(true);
        }

        deleteCookie(Cookies.ADDRESS);
        deleteCookie(Cookies.ZHP_LM_MODULE);
        yield put(setActiveProviderType(ProviderType.TELEKOM));
        yield put(setSelectedTariffId(SELECTEDID));
        yield put(setAccessSupplier(''));
        yield put(setRolloutEndMonth(''));
        yield put(setRolloutStatus(''));
        yield put(setAvailabilityIndicator(''));
        yield call(getOffersSaga);
    } catch (error) {
        debugInfo('Something went wrong while deleting address: ', error);
    }
}

export function* handelLoggedCases(){
    try {
        const MDDKeks = getCookie(Cookies.MDD_KEKS);
        let userInfo: UserInfo = {
            isLogged: false,
            isFixed: false,
            isVKD: false,
            isUM: false,
        };

        if (MDDKeks){
            const authRes: UserInfo = yield call(getUserInfo);

            if (authRes){
                userInfo = authRes;
            }
        }

        yield put(setUserInfo(userInfo));

    } catch (error) {
        debugInfo('Could not handel logged user: ', error);
    }
}

export function* initStoreSaga () {
    yield put(setLoading(true));
    // Remove gigakombi cookie to prevent stucked discount
    yield call(removeGigakombiCookie);
    yield call(handelLoggedCases);
    yield call(handleStepper);
    yield call(validateFFSaga);
    yield call(getOffersSaga);
    yield call(initOverlay);
    yield put(setLoading(false));
}

export default function* saga() {
    yield takeLatest(AppActions.INIT_STORE, initStoreSaga);
    yield takeLatest(AppActions.OPEN_OVERLAY, openOverlaySaga);
    yield takeLatest(AppActions.DELETE_ADDRESS, deleteAddressSaga);
}
